import { UniButton } from '@/design-system/components/buttons';
import { BottomSheetHeader } from '@/design-system/components/headers';
import BottomSheet, { useBottomSheetDynamicSnapPoints, BottomSheetBackdrop } from '@gorhom/bottom-sheet';
import { LayoutContext } from 'contexts/LayoutContext';
import { H6, TextBody, TextCaption } from '@/design-system/components/typography';
import { SxProp, View, Image, useDripsyTheme } from 'dripsy';
import _ from 'lodash';
import React, { useContext, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { LockCardStackParamList, LockCardStackRoutes } from './type';
import { Card } from '../../../../../../packages/utx-access-client/src/react';
import { ButtonVariant } from '@/design-system/components/buttons/useButton.hook';
import { AlertType, UniAlert } from '@/design-system/components/alerts';

export interface UnlockCardProps {
  onClose: () => void;
  account: string;
  tab?: number;
  onType: (value: string | undefined) => void;
  type: string;
  record?: Card;
  func?: (cardId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
  actionResponse?: any;
  actionError?: any;
  onData?: (value: any) => void;
  refresh?: () => void;
}

export const UnlockCardNativeZeroScreen: React.FC<UnlockCardProps> = (props) => {
  const { onClose, account, tab, onType, type, record, func, onData, refresh } = props;
  const { t } = useTranslation('account-management');

  const layout = useContext(LayoutContext);
  const renderBackdrop = useCallback(
    (props) => <BottomSheetBackdrop {...props} disappearsOnIndex={0} appearsOnIndex={1} pressBehavior={'none'} enableTouchThrough={true} />,
    []
  );
  const { width, height } = layout.dimensions;
  const { animatedHandleHeight, animatedSnapPoints, animatedContentHeight, handleContentLayout } = useBottomSheetDynamicSnapPoints([
    'CONTENT_HEIGHT',
    'CONTENT_HEIGHT'
  ]);

  const navigation = useNavigation<NativeStackNavigationProp<LockCardStackParamList>>();
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  return (
    <View sx={{ width, height, backgroundColor: 'transparent' }}>
      <BottomSheet
        enablePanDownToClose
        index={1}
        snapPoints={animatedSnapPoints}
        handleHeight={animatedHandleHeight}
        contentHeight={animatedContentHeight}
        backdropComponent={renderBackdrop}
        handleComponent={() => <View />}>
        <View sx={styles.modal}>
          <View sx={{ minHeight: alertMessage ? 450 : 400, backgroundColor: '$backgroundPrimary' }} onLayout={handleContentLayout}>
            <View sx={styles.topHeader}>
              <BottomSheetHeader
                title={t('card-account-management::unlock-card.title--unlock-instruction-confirmation')}
                onPress={onClose}
              />
            </View>
            <View sx={styles.body}>
              <TextBody sx={styles.textMb} semiBold>
                {t('card-account-management::unlock-card.text--unlock-following-card')}
              </TextBody>
              <View sx={{ alignItems: 'center' }}>
                <Image sx={styles.imageSx} source={record?.product?.imageUrl || require('assets/images/worldcard_blank.png')} />
                <View sx={styles.textGroup}>
                  <View sx={{ gap: '$1' }}>
                    <H6 semiBold sx={{ color: '$white' }}>
                      {record?.embossedName}
                    </H6>
                    <TextCaption sx={{ color: '$white' }}>**** **** **** {record?.last4}</TextCaption>
                  </View>
                </View>
              </View>
              {!_.isEmpty(alertMessage) && <UniAlert type={AlertType.Error} message={alertMessage} sx={{ mt: 5 }} />}
              <View sx={styles.btnView}>
                {/* <UniButton sx={btn} variant={ButtonVariant.outline1} label="Cancel" onPress={onClose} /> */}
                <UniButton
                  sx={styles.btn}
                  loading={loading}
                  labelSx={{ color: '$balck' }}
                  label={t('card-account-management::general.button--place-instruction')}
                  onPress={() => {
                    if (func) {
                      setLoading(true);
                      func(
                        record?.id!,
                        (data) => {
                          setLoading(false);
                          onType(type);
                          onData(data.data);
                          navigation.navigate(LockCardStackRoutes.Placed, {
                            account,
                            tab,
                            type,
                            record,
                            data: data.data,
                            refresh,
                            onLayout: (e) => {}
                          });
                        },
                        (error) => {
                          setLoading(false);
                          setAlertMessage(error?.message);
                        }
                      );
                    }
                  }}
                />
              </View>
            </View>
          </View>
        </View>
      </BottomSheet>
    </View>
  );
};

const styles: Record<string, SxProp> = {
  modal: {
    padding: '$4'
  },
  topHeader: {
    justifyContent: 'center'
  },
  body: {},
  textMb: {
    marginBottom: 20
  },
  imageSx: {
    width: 317,
    height: 200
  },
  btnView: {
    flex: 1,
    gap: '$3',
    mt: '$7'
  },
  btn: {
    width: '100%',
    height: 44
  },
  textGroup: {
    position: 'absolute',
    width: 317,
    height: 200,
    padding: '$5',
    gap: '$3',
    justifyContent: 'flex-end'
  }
};
